import React, { type ReactNode } from 'react';

import { useIntl } from 'react-intl-next';

import { cssMap, cx } from '@atlaskit/css';
import LinkExternalIcon from '@atlaskit/icon/core/link-external';
import { ButtonMenuItem } from '@atlaskit/navigation-system/side-nav-items/button-menu-item';
import { Box } from '@atlaskit/primitives/compiled';
import Spinner from '@atlaskit/spinner';
import { token } from '@atlaskit/tokens';

import { messages } from './messages';

type MenuLoadingItemProps = {
	icon: ReactNode;
	label: ReactNode;
	showLinkIcon?: boolean;
};

const styles = cssMap({
	iconsBlock: {
		paddingInline: token('space.075'),
	},
});

export const MenuLoadingItem = ({ icon, label, showLinkIcon }: MenuLoadingItemProps) => {
	const { formatMessage } = useIntl();
	return (
		<ButtonMenuItem
			elemBefore={icon}
			elemAfter={
				<Box xcss={cx(styles.iconsBlock)}>
					{showLinkIcon ? (
						<LinkExternalIcon label={formatMessage(messages.loadingItemAriaLabel)} size="small" />
					) : (
						<Spinner size="small" />
					)}
				</Box>
			}
			testId="menu-button-loading"
		>
			{label}
			<span aria-label={formatMessage(messages.loadingItemAriaLabel)} />
		</ButtonMenuItem>
	);
};
